export enum InitialDataSectionFieldKey {
    REGISTRATION_NUMBER = 'registrationNumber',
    UNKNOWN_REGISTRATION_NUMBER = 'unknownRegistrationNumber',
    BIRTH_DATE = 'birthDate'
}
